import { useEffect } from "react";
import { SchemaData, UseGetItemProps } from "./types";
import schemaJson from "../schemaUpdate/SchemaJson.json";
import UISchemaJson from "../schemaUpdate/UISchema.json";
import { GET_ITEM_QUERY, GetItemGql } from "../queries/getItem";
import { ApiAuthRequest } from "data/ApiForm";
import { removeNullValues } from "utils/removeNullValues";

const useGetItem = ({ setState, setTemplate, queryParam }: UseGetItemProps<SchemaData>) => {
  useEffect(() => {
    if (!!queryParam) {
      setState((props) => ({
        ...props,
        loading: true,
        messageError: undefined,
        criticalError: undefined,
      }));

      ApiAuthRequest<GetItemGql>({
        query: GET_ITEM_QUERY,
        variables: isNaN(Number(queryParam)) ? { slug: queryParam } : { id: Number(queryParam) },
      })
        .then((response) => {
          if (!response?.data?.data?.Form) {
            throw new Error("Não encontrado", {
              cause: { response: response?.data || response },
            });
          }

          const data = response.data.data?.Form;

          setState({
            data: {
              ...removeNullValues(data),
              formProperties: data?.formProperties?.map((property) => removeNullValues(property)),
            },
            loading: false,
          });
          setTemplate({
            schemaJson: schemaJson,
            UISchema: UISchemaJson,
          });
        })
        .catch((error) => {
          console.log({ error });

          setState((prev) => ({
            ...prev,
            loading: false,
            criticalError: error?.response?.data?.errors?.[0] || error,
          }));
        });
    }
  }, [queryParam]);
};

export default useGetItem;
